"use strict";
/**
 * Copied (and remove obsolete functionalities) from https://github.com/aptos-labs/aptos-core/blob/main/ecosystem/typescript/sdk/src/hex_string.ts because
 * - We only care about address validation and conversion, this is a dependency for AccountAddress
 * - Resolving this dependency in UMD gives dependency errors
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexString = void 0;
var utils_1 = require("@noble/hashes/utils");
/**
 * A util class for working with hex strings.
 * Hex strings are strings that are prefixed with `0x`
 */
var HexString = /** @class */ (function () {
    /**
     * Creates new HexString instance from regular string. If specified string already starts with "0x" prefix,
     * it will not add another one
     * @param hexString String to convert
     * @example
     * ```
     *  const string = "string";
     *  new HexString(string); // "0xstring"
     * ```
     */
    function HexString(hexString) {
        if (hexString.startsWith('0x')) {
            this.hexString = hexString;
        }
        else {
            this.hexString = "0x".concat(hexString);
        }
    }
    /**
     * Creates new hex string from Buffer
     * @param buffer A buffer to convert
     * @returns New HexString
     */
    HexString.fromBuffer = function (buffer) {
        return HexString.fromUint8Array(buffer);
    };
    /**
     * Creates new hex string from Uint8Array
     * @param arr Uint8Array to convert
     * @returns New HexString
     */
    HexString.fromUint8Array = function (arr) {
        return new HexString((0, utils_1.bytesToHex)(arr));
    };
    /**
     * Ensures `hexString` is instance of `HexString` class
     * @param hexString String to check
     * @returns New HexString if `hexString` is regular string or `hexString` if it is HexString instance
     * @example
     * ```
     *  const regularString = "string";
     *  const hexString = new HexString("string"); // "0xstring"
     *  HexString.ensure(regularString); // "0xstring"
     *  HexString.ensure(hexString); // "0xstring"
     * ```
     */
    HexString.ensure = function (hexString) {
        if (typeof hexString === 'string') {
            return new HexString(hexString);
        }
        return hexString;
    };
    /**
     * Getter for inner hexString
     * @returns Inner hex string
     */
    HexString.prototype.hex = function () {
        return this.hexString;
    };
    /**
     * Getter for inner hexString without prefix
     * @returns Inner hex string without prefix
     * @example
     * ```
     *  const hexString = new HexString("string"); // "0xstring"
     *  hexString.noPrefix(); // "string"
     * ```
     */
    HexString.prototype.noPrefix = function () {
        return this.hexString.slice(2);
    };
    /**
     * Overrides default `toString` method
     * @returns Inner hex string
     */
    HexString.prototype.toString = function () {
        return this.hex();
    };
    /**
     * Trimmes extra zeroes in the begining of a string
     * @returns Inner hexString without leading zeroes
     * @example
     * ```
     *  new HexString("0x000000string").toShortString(); // result = "0xstring"
     * ```
     */
    HexString.prototype.toShortString = function () {
        var trimmed = this.hexString.replace(/^0x0*/, '');
        return "0x".concat(trimmed);
    };
    /**
     * Converts hex string to a Uint8Array
     * @returns Uint8Array from inner hexString without prefix
     */
    HexString.prototype.toUint8Array = function () {
        return Uint8Array.from((0, utils_1.hexToBytes)(this.noPrefix()));
    };
    return HexString;
}());
exports.HexString = HexString;
//# sourceMappingURL=HexString.js.map